import React, { useId } from 'react';

const MatchbackAudienceIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const gradientId = useId();

  return (
    <svg width="22" height="13" viewBox="0 0 22 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="6.4131" cy="6.4131" r="6.4131" fill="#DAF2FF" />
      <circle cx="14.6572" cy="6.4131" r="6.1631" stroke={`url(#${gradientId})`} strokeWidth="0.5" />
      <circle cx="14.6572" cy="6.4131" r="6.1631" stroke="white" strokeOpacity="0.1" strokeWidth="0.5" />
      <defs>
        <linearGradient
          id={gradientId}
          x1="8.24414"
          y1="1.20246"
          x2="22.0874"
          y2="3.50486"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1784EC" />
          <stop offset="0.5" stopColor="#FF8FA1" />
          <stop offset="1" stopColor="#FF6C0A" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default MatchbackAudienceIcon;
